var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2026-10-22T13:58:38-main-a76d8d0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["squad-inbox@supercell"]={id:"2026-10-22T13:58:38-main-a76d8d0"};
      